import script from "./CheckboxArea.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckboxArea.vue?vue&type=script&setup=true&lang=js"

import "./CheckboxArea.vue?vue&type=style&index=0&id=0b1e421e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b1e421e"]])

export default __exports__